import Clients from "../views/clientClientPortal/clientForClient/client";
import MessageCampaign from "../views/clientClientPortal/messagesCampaign";

import TeamIcon from "../assets/icons/team.svg";
import TeamHoverIcon from "../assets/icons/team-hover.svg";
import MessageIcon from "../assets/icons/mail.svg";
import MessageHoverIcon from "../assets/icons/mailOrange.svg";

const routesClients = [
    {
        id: "cm2",
        path: "/manager",
        name: "Gerenciar",
        icon: TeamIcon,
        iconHover: TeamHoverIcon,
        layout: "/client",
        component: Clients,
        redirect: false,
    },

    {
        id: "cm2a2",
        path: "/message",
        name: "Mensagens",
        icon: MessageIcon,
        iconHover: MessageHoverIcon,
        layout: "/client",
        component: MessageCampaign,
        redirect: false,
    },
]

export default routesClients;